import React from 'react';
import SectorContentBox from './SectorContentbox';
import content from './PagesContent/content';
import SectorFirstPage from './SectorFirstPage';
import SectorCarousal from '../carousal/SectorCarousal';

export default function FinacialSector() {
    return (
        <>
            <SectorFirstPage content={content.page2} />
            {content.page2.contentpage.map((element, index) => (
                <React.Fragment key={index}>
                    <SectorContentBox pagecontent={element} />
                    <hr />
                </React.Fragment>
            ))}
            <SectorCarousal removeroute={"/financial"}/>
        </>
    );
}
